import Vue from 'vue';
import VueSlider from 'vue-slider-component'

// Get calc data
//
import { calcData, termBandFor } from '../shared/calc-data.js'

const numeral = require("numeral");

Vue.filter("formatCurrency", function (value) {
    return numeral(value).format("0,0.00");
});

Number.isInteger = Number.isInteger || function (value) {
    return typeof value === "number" &&
        isFinite(value) &&
        Math.floor(value) === value;
};

//Vue.config.productionTip = false
if (document.querySelector('#calc')) {
    const calc = new Vue({
        el: '#calc',
        delimiters: ['${', '}'],

        components: {
            VueSlider
        },

        // merge modal state into the calc data
        data: function() {
            return Object.assign({}, calcData, {
                // legacy confirm modal (not used now)
                confirmModalVisible: false,
                // redirect modal state
                redirectModalVisible: false,
                // feature flag to control whether to show the redirect popup
                isShowRedirectionPopup: false,
                redirectCountdown: 5,
                _redirectTimer: null,
            });
        },

        watch: {
            termSliderValue: function (val) {
                this.loanTerm = val;
                this.calculate();
            },
            loanSliderValue: function (val) {
                this.loanValue = val;
                this.calculate();
            }
        },

        created() {
            //SET A SLIDER DEFAULT
            this.loanSliderValue = this.prevLoanValue = this.minLoanValue;
            this.termSliderValue = this.prevLoanTerm = this.minTerm;
        },

        mounted() {
            if (this.$refs.apr) {
                this.apr = this.$refs.apr.value / 100;
            }

            if (this.$refs.enquiryUrl) {
                this.queryStr = window.location.search.replace('?', '');
                this.enquiryUrl = this.$refs.enquiryUrl.value;
            }

            if (this.$refs.defaultLoanValue) {
                let defaultLoanValue = parseInt(this.$refs.defaultLoanValue.value);
                if (defaultLoanValue >= this.minLoanValue && defaultLoanValue <= this.maxLoanValue) {
                    this.loanValue = defaultLoanValue;

                }
            }

            if (this.$refs.defaultLoanTerm && this.$refs.defaultLoanTerm.value) {
                let defaultLoanTerm = parseInt(this.$refs.defaultLoanTerm.value);
                if (defaultLoanTerm >= this.minTerm && defaultLoanTerm <= this.maxTerm) {
                    this.loanTerm = defaultLoanTerm;

                }
            }

            // No valid default term passed in (e.g. calculators in blog posts): use the standard
            // default, as the server-rendered figures do (templates/_macros/calc.twig)
            if (!this.loanTerm) {
                this.loanTerm = this.defaultLoanTerm;
            }

            this.loanSliderValue = this.loanValue;
            this.termSliderValue = this.loanTerm;

            for (let ref in this.$refs) {
                this.$refs[ref].parentNode.removeChild(this.$refs[ref]);
            }

            // read feature flag from hidden input (if present)
            if (this.$refs.isShowRedirectionPopup) {
                try {
                    this.isShowRedirectionPopup = (this.$refs.isShowRedirectionPopup.value === 'true');
                } catch (e) {
                    this.isShowRedirectionPopup = false;
                }
            }

            this.calculate();

            document.querySelector('#calc').classList.add('calc-loaded')
        },

        methods: {
            // Same format as the formatCurrency filter, for v-text bindings
            formatCurrency(value) {
                return numeral(value).format("0,0.00");
            },

            // open the redirect modal and start countdown
            openConfirmModal() {
                // For backwards compatibility, call the new redirect flow
                this.openRedirectModal();
            },

            openRedirectModal() {
                // ensure calculations are up to date so buttonLink is correct
                this.calculate();

                // show the modal even if buttonLink isn't set (calculate may have returned early)
                this.redirectCountdown = 5;
                this.redirectModalVisible = true;
                // prevent background scroll and force top stacking
                try { document.body.classList.add('oakbrook-modal-open'); } catch (e) {}

                // always start timer so user sees the countdown
                this.startRedirectCountdown();
            },

            startRedirectCountdown() {
                // clear any existing timer
                this.stopRedirectCountdown();

                const self = this;
                this._redirectTimer = setInterval(function() {
                    if (self.redirectCountdown <= 1) {
                        self.stopRedirectCountdown();
                        self.performRedirect();
                        return;
                    }
                    self.redirectCountdown = self.redirectCountdown - 1;
                }, 1000);
            },

            stopRedirectCountdown() {
                if (this._redirectTimer) {
                    clearInterval(this._redirectTimer);
                    this._redirectTimer = null;
                }
            },

            // user clicked the CTA inside the modal
            confirmRedirect() {
                this.stopRedirectCountdown();
                this.performRedirect();
            },

            // hide the modal without redirecting
            cancelEligibility() {
                this.redirectModalVisible = false;
                this.stopRedirectCountdown();
                try { document.body.classList.remove('oakbrook-modal-open'); } catch (e) {}
            },

            performRedirect() {
                // hide modal then redirect
                this.redirectModalVisible = false;
                try { document.body.classList.remove('oakbrook-modal-open'); } catch (e) {}
                // use buttonLink (already built by calculate()), fallback to enquiryUrl
                const target = this.buttonLink || this.enquiryUrl;
                if (target) {
                    window.location.href = target;
                }
            },

            calculate() {
                //CHECK LOAN VALUE
                if (!this.loanValue) {
                    return;
                }

                // Term range depends on the amount (rules in templates/_data/calculator-limits.json)
                const band = termBandFor(this.loanValue);
                this.minTerm = band.minTerm;
                this.maxTerm = band.maxTerm;

                if (!Number.isInteger(+this.loanValue)) {
                    this.loanValue = this.prevLoanValue;
                    return;
                }

                if (+this.loanValue < this.minLoanValue || +this.loanValue > this.maxLoanValue) {

                    if (+this.loanValue < this.minLoanValue) {
                        this.loanValue = this.minLoanValue;
                        this.loanSliderValue = this.minLoanValue;
                        document.querySelector('.calc__update p').innerHTML = 'Min loan value £' + this.minLoanValue;
                        document.querySelector('.calc__update').classList.add('show')

                        setTimeout(function () {
                            document.querySelector('.calc__update').classList.remove('show')
                        }, 3500);
                    }

                    if (+this.loanValue > this.maxLoanValue) {
                        this.loanValue = this.maxLoanValue;
                        this.loanSliderValue = this.maxLoanValue;
                        document.querySelector('.calc__update p').innerHTML = 'Max loan value £' + this.maxLoanValue;
                        document.querySelector('.calc__update').classList.add('show')

                        setTimeout(function () {
                            document.querySelector('.calc__update').classList.remove('show')
                        }, 3500);
                    }

                    //this.loanValue = this.prevLoanValue;

                    return;
                }

                //CHECK LOAN TERM
                if (!this.loanTerm) {
                    return;
                }

                if (!Number.isInteger(+this.loanTerm)) {
                    this.loanTerm = this.prevLoanTerm;
                    return;
                }

                if (+this.loanTerm < this.minTerm || +this.loanTerm > this.maxTerm) {

                    if (+this.loanTerm < this.minTerm) {
                        this.loanTerm = this.minTerm;
                        this.termSliderValue = this.minTerm;

                        document.querySelector('.calc__update p').innerHTML = 'Min term is ' + this.minTerm + ' months';
                        document.querySelector('.calc__update').classList.add('show')
                        setTimeout(function () {
                            document.querySelector('.calc__update').classList.remove('show')
                        }, 3500);
                    }

                    if (+this.loanTerm > this.maxTerm) {
                        this.loanTerm = this.maxTerm;
                        this.termSliderValue = this.maxTerm;

                        document.querySelector('.calc__update p').innerHTML = 'Max term is ' + this.maxTerm + ' months';
                        document.querySelector('.calc__update').classList.add('show')
                        setTimeout(function () {
                            document.querySelector('.calc__update').classList.remove('show')
                        }, 3500);

                    }

                    //this.loanTerm = this.prevLoanTerm;
                    return;
                }


                this.loanValue = Math.round(this.loanValue / this.loanIncrement) * this.loanIncrement;

                this.loanSliderValue = this.prevLoanValue = this.loanValue;
                this.termSliderValue = this.prevLoanTerm = this.loanTerm;

                const monthlyInterestRate = Math.pow(1 + this.apr, 1 / 12) - 1;

                this.monthlyRepaymentAmount = +((monthlyInterestRate * this.loanValue * Math.pow((1 + monthlyInterestRate), this.loanTerm)) / (Math.pow(1 + monthlyInterestRate, this.loanTerm) - 1)).toFixed(2);
                this.totalRepayableAmount = +(this.monthlyRepaymentAmount * this.loanTerm).toFixed(2);
                if(this.isShowRedirectionPopup) {
                    this.buttonLink = this.enquiryUrl + "?LoanAmount=" + this.loanValue + "&LoanTermInMonths=" + this.loanTerm + "&utm_source=oa&" + this.queryStr;
                } else {
                    this.buttonLink = this.enquiryUrl + "?LoanAmount=" + this.loanValue + "&LoanTermInMonths=" + this.loanTerm + "&" + this.queryStr;
                }

                let buttons = document.querySelectorAll('.update-quote-link');
                for (let i = 0; i < buttons.length; i++) {
                    // buttons[i].href = this.enquiryUrl + "?LoanAmount=" + this.loanValue + "&LoanTermInMonths=" + this.loanTerm + "&utm_source=oa&" + this.queryStr;
                    buttons[i].href = this.buttonLink;
                }
            }
        }
    });
}




